import api from "./api";
import config from "../config";
import { stringify } from "qs";

export default {
  delete(person, ticket) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `tickets/${ticket}/customer_delete`,
          qs: { token: person }
        },
        function(err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  transfer(token, { ids, destinationEmail }) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `tickets/transfer`,
          json: {
            token: token,
            tickets: ids,
            recipient: destinationEmail
          }
        },
        function(err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  resendTransfer(token, id) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `tickets/resend_transfer`,
          json: { token, transfer: id }
        },
        function(err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  cancelTransfer(token, id) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `tickets/cancel_transfer`,
          json: { token, transfer: id }
        },
        function(err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  acceptTransfer(personToken, id, transferToken) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `tickets/accept_transfer`,
          json: {
            transfer: id,
            transfer_token: transferToken,
            token: personToken
          }
        },
        function(err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  downloadPdf(person, event) {
    let query = stringify({
      token: person,
      event: event,
      event_bucket: config.event_bucket,
      api_key: config.api_key
    });

    window.open(config.endpoint + `people/self/tickets.pdf?${query}`, "_blank");
  }
};



// WEBPACK FOOTER //
// ./src/app/utils/TicketUtil.js